/**
 * Wrap perf observers and async hooks into convenience utilities.
 *
 * @author Timir Hazarika <thazarik@cisco.com>
 *
 * @copyright Cisco Systems, Inc. All rights reserved.
 */

const runOnceCache: any = {};
const runOnce = (fn: Function, id: string) => {
  if (runOnceCache[id]) return;
  fn();
  runOnceCache[id] = true;
}

let lcpObserver: PerformanceObserver;

const recordLcp = () => {
  lcpObserver = new PerformanceObserver(list => {
    const entries = list.getEntries();
    const el = entries[entries.length - 1];
    console.log('Element responsible for the largest contentful paint', el);
  });
  lcpObserver.observe({ type: "largest-contentful-paint", buffered: true })
}

const disconnect = () => {
  lcpObserver && lcpObserver.disconnect();
  Object.keys(runOnceCache).forEach(key => delete runOnceCache[key]);
}

/**
 * The public performance monitor API for this app
 */
export const PerformanceMonitor = {
  recordLcp: () => runOnce(recordLcp, 'perfmon-lcp'),
  exit: disconnect
};

